import { Text, H5 } from 'components'
import { Button } from '@nextretreat/ui-components/dist/Button'
import styled from '@emotion/styled'
import theme from '@nextretreat/ui-components/dist/Theme'

interface IWelcomeMessageProps {
  /**
   * Callback for 'List venue' button click
   */
  onList: () => void
}

const StyledText = styled(Text)`
  font-size: ${theme.fontSizes.m};
  line-height: ${theme.lineHeights.m};
`

StyledText.defaultProps = {
  as: 'p',
  textAlign: 'justify',
}

export const WelcomeMessage = ({ onList }: IWelcomeMessageProps) => {
  return (
    <>
      <H5
        lineHeight={theme.lineHeights.l}
        as="p"
        textAlign="center"
        fontWeight={590}
        marginBottom={30}
      >
        List your hotel, villa, house or other unique venue on NextRetreat!
      </H5>

      <StyledText marginBottom={20}>
        NextRetreat is designed exclusively for teams and we strive to offer
        venues that are most suitable for company retreats, offsites and other
        team trips.
      </StyledText>

      <StyledText marginBottom={20}>
        Please mind that after publishing you won't be able to edit the listing
        manually, only by contacting{' '}
        <a href="mailto:support@nextretreat.com">support@nextretreat.com</a>. So
        please make sure you submit all the necessary information correctly and
        upload the best photos of your property.
      </StyledText>

      <StyledText marginBottom={32}>
        After submitting your request, it may take up to 7 days to process it.
        If your property & listing is approved, it will be published in the
        NextRetreat inventory.
      </StyledText>

      <Button.Primary type="button" onClick={onList}>
        List your Venue
      </Button.Primary>
    </>
  )
}
